import React from 'react';
import PropTypes from 'prop-types';

import Slot from '../../Slot';
import VerticalBarsByStateChart from '../../Charts/VerticalBarsByStateChart';
import './styles.css';

class VerticalBarsByState extends React.Component {
  render() {
    const {
      states,
      sufix,
      selector,
    } = this.props;

    return (
      <div className="TwoLinesContent__root">
        <div className="TwoLinesContent__flex__row">
          <Slot
            empty
          >
            <VerticalBarsByStateChart
              states={states}
              sufix={sufix}
              selector={selector}
            />
          </Slot>
        </div>
      </div>
    );
  }
}

VerticalBarsByState.propTypes = {
  states: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default VerticalBarsByState;
